import * as Yup from 'yup';

export const triggersTabFiltersSchema = () =>
  Yup.object({
    actionTypes: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    channels: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    eventTypes: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    properties: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    recipients: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
    templateUids: Yup.array()
      .of(Yup.object({ label: Yup.string(), value: Yup.string() }))
      .nullable(),
  });

export type TriggersTabFiltersSchemaType = Yup.InferType<
  ReturnType<typeof triggersTabFiltersSchema>
>;

export const getFormDefaultValues = (): TriggersTabFiltersSchemaType => {
  return {
    actionTypes: [],
    channels: [],
    eventTypes: [],
    properties: [],
    recipients: [],
    templateUids: [],
  };
};
